module.exports = {
    urlAPI:
        process.env.REACT_APP_API_URL ||
        'https://kumwellslms.ubonmicrotech.com',
    urlAPIWs:
        process.env.REACT_APP_API_URL_WS || 'kumwellslms.ubonmicrotech.com',
}

const { urlAPI } = require('./apiConfig')
const { urlAPIWs } = require('./apiConfig')

const urlConfig = {
    baseUrlAPI:
        process.env.REACT_APP_API_URL ||
        'https://kumwellslms.ubonmicrotech.com',
    // process.env.REACT_APP_API_URL ||
    loginUser: `${urlAPI}/api/v1/auth/login`,
    loginOut: `${urlAPI}/api/v1/auth/logout`,
    myToken: `${urlAPI}/api/v1/auth/my-account`,
    reToken: `${urlAPI}/api/v1/auth/refresh-token`,
    logout: `${urlAPI}/api/v1/auth/logout`,
    permission: `${urlAPI}/api/v1/permission`,
    role: `${urlAPI}/api/v1/role`,
    organization: `${urlAPI}/api/v1/organization`,
    user: `${urlAPI}/api/v1/user`,
    deviceHistoryGraph: `${urlAPI}/api/v1/device/history-graph`,
    deviceHistoryTime: `${urlAPI}/api/v1/device/history-time`,
    deviceById: `${urlAPI}/api/v1/device/id`,
    deviceType: `${urlAPI}/api/v1/device-type`,
    deviceIot: `${urlAPI}/api/v1/device`,
    weather: `${urlAPI}/api/v1/weather`,
    airPollution: `${urlAPI}/api/v1/air_pollution`,
    notificationSetting: `${urlAPI}/api/v1/notification-setting`,
    gateway: `${urlAPI}/api/v1/gateway`,
    image: `${urlAPI}/api/v1`,
    device: `${urlAPI}/api/v1/device`,
    card: `${urlAPI}/api/v1/card`,
    imageByKey: `${urlAPI}/api/v1/images/organization`,
    realtime: `${urlAPI}/api/v1/real-time-log`,
    alarmLog: `${urlAPI}/api/v1/alarm-log`,
    historylog: `${urlAPI}/api/v1/history-log`,
    settingHistoryLog: `${urlAPI}/api/v1/setting-history-log`,
    export: `${urlAPI}/api/v1/report`,
    sound: `${urlAPI}/api/v1/sound`,
    lineOA: `${urlAPI}/api/v1/line-oa`,
    lineOA_accessToken: `${urlAPI}/api/v1/line-oa/channel-token`,
    reset_pw : `${urlAPI}/api/v1/user/set-new-password`,
    smtp: `${urlAPI}/api/v1/smtp`,
    forgot: `${urlAPI}/api/v1/forgot-password/send-reset-link`,
    forgot_validate: `${urlAPI}/api/v1/forgot-password/validate-token`,
    forgot_setPassword: `${urlAPI}/api/v1/forgot-password/reset-password`,
    test_send: `${urlAPI}/api/v1/webhook/message`,

    //*--Websocket--//
    wbRealTime: `wss://${urlAPIWs}/websocket`,
    wbAlarm: `wss://${urlAPIWs}/websocket`,
    wbDevice: `wss://${urlAPIWs}/websocket`,
}

module.exports = { urlConfig }
